// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   development: true,
//   currentEnv: 'dev' as 'dev' | 'stg' | 'prod',
//   firebase: {
//     // 🔧 REEMPLAZA estos valores con los de tu proyecto de BACKOFFICE desarrollo
//     // NOTA: Estos deberían ser los valores del backoffice, no de sa-rokit-pwa
//     apiKey: 'AIzaSyC8AbdJZGXAku1JNnDx46fGfi3o14bgw2w',
//     authDomain: 'dev-rokit-bo.firebaseapp.com',
//     projectId: 'dev-rokit-bo',
//     storageBucket: 'dev-rokit-bo.firebasestorage.app',
//     messagingSenderId: '998339985387',
//     appId: '1:998339985387:web:c530260cf4c8721a3163ae',
//   },
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

export const environment = {
  production: false,
  development: true,
  // firebase: {
  //   apiKey: 'AIzaSyBMkqS3Uh9A1I_1cjXLbPs0K2EtwaXV86Y',
  //   authDomain: 'app-dev.rokit.travel',
  //   databaseURL: 'https://sa-rokit-pwa-dev.firebaseio.com',
  //   projectId: 'sa-rokit-pwa-dev',
  //   storageBucket: 'sa-rokit-pwa-dev.appspot.com',
  //   messagingSenderId: '775874859647',
  //   appId: '1:775874859647:web:581575989279517938654a',
  //   measurementId: 'G-NSYMYPN5BL',
  // },
  // URLs de Cloud Functions para SSO a través del hosting de Rokit
  // Las funciones están deployadas en sa-rokit-pwa-dev y accesibles via rewrites
  // sso: {
  //   createSessionUrl: 'nonecesitoesto',
  //   verifySessionUrl: 'https://app-dev.rokit.travel/api/verifySession',
  //   revokeSessionUrl: 'https://app-dev.rokit.travel/api/revokeSession',
  // },
  // API URL
  apiUrl: 'https://api-dev-775874859647.us-central1.run.app',
  // Google OAuth Client ID for Google Sign-In (get from Google Cloud Console)
  googleClientId: '775874859647-a0unik7hm3steiri75d7u33heaac54me.apps.googleusercontent.com',
};
